var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 6.125H8.125V4.875H6.875M7.5 13C4.74375 13 2.5 10.7563 2.5 8C2.5 5.24375 4.74375 3 7.5 3C10.2563 3 12.5 5.24375 12.5 8C12.5 10.7563 10.2563 13 7.5 13ZM7.5 1.75C6.67924 1.75 5.86651 1.91166 5.10823 2.22575C4.34994 2.53984 3.66095 3.00022 3.08058 3.58058C1.90848 4.75269 1.25 6.3424 1.25 8C1.25 9.6576 1.90848 11.2473 3.08058 12.4194C3.66095 12.9998 4.34994 13.4602 5.10823 13.7742C5.86651 14.0883 6.67924 14.25 7.5 14.25C9.1576 14.25 10.7473 13.5915 11.9194 12.4194C13.0915 11.2473 13.75 9.6576 13.75 8C13.75 7.17924 13.5883 6.36651 13.2742 5.60823C12.9602 4.84994 12.4998 4.16095 11.9194 3.58058C11.3391 3.00022 10.6501 2.53984 9.89177 2.22575C9.13349 1.91166 8.32076 1.75 7.5 1.75ZM6.875 11.125H8.125V7.375H6.875V11.125Z",
    fill: "#E48900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowInfo);
export default __webpack_public_path__ + "static/media/yellow-info.881b7a7b2fd9b3062dc1a6c59d3ce860.svg";
export { ForwardRef as ReactComponent };